/**
 * Adds the current product to the cart, then sends the shopper straight to checkout.
 * Used by the "Buy now" button rendered in the buy buttons block.
 */
const buyNowSelector = '[data-buy-now-button]';

/**
 * @param {Event} event
 */
async function handleBuyNowClick(event) {
  const button = /** @type {HTMLButtonElement} */ (event.target instanceof Element ? event.target.closest(buyNowSelector) : null);
  if (!button || button.disabled) return;

  const form = button.closest('form');
  if (!form) return;

  button.disabled = true;

  try {
    const formData = new FormData(form);
    const response = await fetch(button.dataset.cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);

    window.location.href = button.dataset.checkoutUrl;
  } catch (error) {
    console.error(error);
    button.disabled = false;
  }
}

document.addEventListener('click', handleBuyNowClick);
